import { useTranslation } from 'react-i18next';
import { AccordionDetails } from '@mui/material';
import React, { useState } from 'react';
import OrderDetails from '../../OrderDetails';
import { Accordion, AccordionSummary, AccordionSummaryVariant } from '../Accordion';
import { EditOrderPanels } from '../../EditOrderDialog';
import { OrderData } from '../../../../../api';
import { ExperienceDetailSummary } from './ExperienceDetailSummary';
import { ExtraItemsQuickAction } from './ExtraItemsQuickAction';

type ExperienceDetailPanelProps = {
  detailsStepErrors: Record<string, any>;
  isLoadingDates: boolean;
  expanded?: EditOrderPanels;
  handleChange: any;
  hidePricing?: boolean;
  onOrderUpdated?: (order: OrderData) => void;
  focusExtraItems?: boolean;
};
export const ExperienceDetailPanel = ({
  detailsStepErrors,
  isLoadingDates,
  expanded,
  handleChange,
  hidePricing,
  onOrderUpdated,
  focusExtraItems,
}: ExperienceDetailPanelProps) => {
  const { t } = useTranslation();
  const [quickAction, setQuickAction] = useState<{ type: ExtraItemsQuickAction; token: number } | null>(null);
  const isExpanded = expanded === EditOrderPanels.ExperienceDetailPanel || expanded === EditOrderPanels.AllOpen;
  const requestQuickAction = (event: React.SyntheticEvent, type: ExtraItemsQuickAction) => {
    handleChange(EditOrderPanels.ExperienceDetailPanel)(event, true);
    setQuickAction((previous) => ({ type, token: (previous?.token ?? 0) + 1 }));
  };
  return (
    <Accordion
      onChange={handleChange}
      expandedPanelName={expanded}
      panelName={EditOrderPanels.ExperienceDetailPanel}
      allOpenValue={EditOrderPanels.AllOpen}>
      <AccordionSummary
        variant={AccordionSummaryVariant.CAPTION}
        title={t('calendar.edit_order.experience')}
        summaryComponent={
          <ExperienceDetailSummary
            hidePricing={hidePricing}
            isPanelExpanded={isExpanded}
            onQuickAction={requestQuickAction}
          />
        }
      />
      <AccordionDetails>
        <OrderDetails
          errors={detailsStepErrors}
          isLoadingDates={isLoadingDates}
          hidePricing={hidePricing}
          onOrderUpdated={onOrderUpdated}
          focusExtraItems={focusExtraItems}
          requestedAction={quickAction}
        />
      </AccordionDetails>
    </Accordion>
  );
};
